import React from "react";
import { Title, Text, Stack, Box } from "@mantine/core";
import styles from "./OnboardingStepCard.module.css";

interface OnboardingStepCardProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}

export default function OnboardingStepCard({
  title,
  subtitle,
  children,
}: OnboardingStepCardProps) {
  return (
    <Stack gap="md" className={styles.card}>
      <Stack gap="xs" className={styles.header}>
        <Title order={1} className={styles.title}>
          {title}
        </Title>
        <Text size="sm" c="dimmed" className={styles.subtitle}>
          {subtitle}
        </Text>
      </Stack>
      <Box className={styles.content}>{children}</Box>
    </Stack>
  );
}
